import { PropsWithChildren, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const Icon = ({ children, ...props }: PropsWithChildren<IconProps>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={1.8}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		{...props}>
		{children}
	</svg>
)

export const GridIcon = (props: IconProps) => (
	<Icon {...props}>
		<path d="M12 3v18" />
		<path d="M3 12h18" />
		<rect x="3" y="3" width="18" height="18" rx="2" />
	</Icon>
)

export const MoveIcon = (props: IconProps) => (
	<Icon {...props}>
		<path d="M12 2v20" />
		<path d="m15 19-3 3-3-3" />
		<path d="m19 9 3 3-3 3" />
		<path d="M2 12h20" />
		<path d="m5 9-3 3 3 3" />
		<path d="m9 5 3-3 3 3" />
	</Icon>
)

export const RotateLeftIcon = (props: IconProps) => (
	<Icon {...props}>
		<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
		<path d="M3 3v5h5" />
	</Icon>
)

export const ScalingIcon = (props: IconProps) => (
	<Icon {...props}>
		<path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
		<path d="M14 15H9v-5" />
		<path d="M16 3h5v5" />
		<path d="M21 3 9 15" />
	</Icon>
)
